// This icon file is generated automatically.
var PRollbackOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.4 1.78H3.71V.62c0-.1-.12-.16-.2-.1L1.3 2.29a.12.12 0 000 .2l2.22 1.74c.08.07.2.01.2-.1V2.98h6.48v7.34H.73a.13.13 0 00-.12.13v.94c0 .06.06.12.12.12h9.66a1 1 0 001-1V2.78a1 1 0 00-1-1z", "fill-rule": "nonzero" } }] }, "name": "p-rollback", "theme": "outlined" };
export default PRollbackOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRollbackOutlined.js
// module id = 3602
// module chunks = 0